import React, { useState } from "react";
import axios from "axios";
import { BiCategory } from "react-icons/bi";
import Style from "../Style/Subcatgory.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const Subcatgory = () => {
  const [formData, setFormData] = useState({
    skill_id: "",
    course: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${baseURL}/api/skill-details`, formData);
      console.log("Success:", res.data);
      alert("Data submitted successfully!");
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to submit data");
    }
  };

  return (
    <div className={Style.SubcatgoryForm}>
      <h2>
        <BiCategory style={{ marginRight: "8px", verticalAlign: "middle" }} />
        Add Subcategory
      </h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Skill ID:</label>
          <input
            type="text"
            name="skill_id"
            value={formData.skill_id}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Subcategory Name:</label>
          <input
            type="text"
            name="course"
            value={formData.course}
            onChange={handleChange}
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Subcatgory;
